// extracted by mini-css-extract-plugin
export var exit = "_7-3";
export var notificationContainer = "_7-1";
export var notificationStack = "_7-0";
export var shrinkFadeOut = "_7-4";
export var slideInUp = "_7-2";